jQuery(document).ready(function ($) {
	$(".galeria .items").slick({
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: true,
		dots: false,
		prevArrow:
			'<a class="slick-arrow slick-arrow-prev" href="javascript:void(null);">&leftarrow;</a>',
		nextArrow:
			'<a class="slick-arrow slick-arrow-next" href="javascript:void(null);">&rightarrow;</a>',
	});

	$("#galeria-aerea .items").slick({
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: true,
		dots: false,
		prevArrow:
			'<a class="slick-arrow slick-arrow-prev" href="javascript:void(null);">&leftarrow;</a>',
		nextArrow:
			'<a class="slick-arrow slick-arrow-next" href="javascript:void(null);">&rightarrow;</a>',
	});

	$("#galeria-nahuen .galeria-interior .items").slick({
		infinite: true,
		slidesToShow: 4,
		slidesToScroll: 1,
		autoplay: true,
		dots: false,
		appendArrows: $("#galeria-nahuen").find(".arrows"),
		prevArrow:
			'<a class="slick-arrow slick-arrow-prev" href="javascript:void(null);">&#10094;</a>',
		nextArrow:
			'<a class="slick-arrow slick-arrow-next" href="javascript:void(null);">&#10095;</a>',
		responsive: [
			{
				breakpoint: 738,
				settings: {
					slidesToShow: 1,
				}
			}
		]
	});

	$("#galeria-ollagua .galeria-interior .items").slick({
		infinite: true,
		slidesToShow: 4,
		slidesToScroll: 1,
		autoplay: true,
		dots: false,
		appendArrows: $("#galeria-ollagua").find(".arrows"),
		prevArrow:
			'<a class="slick-arrow slick-arrow-prev" href="javascript:void(null);">&#10094;</a>',
		nextArrow:
			'<a class="slick-arrow slick-arrow-next" href="javascript:void(null);">&#10095;</a>',
		responsive: [
			{
				breakpoint: 738,
				settings: {
					slidesToShow: 1,
				}
			}
		]
	});

	$(".terminaciones .items").slick({
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: true,
		dots: false,
		arrows: false,
		responsive: [
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 3,
				}
			},
			{
				breakpoint: 738,
				settings: {
					slidesToShow: 2,
				}
			}
		]
	});

	$("#terminaciones")
		.find('a[data-toggle="tab"]')
		.on("show.bs.tab", function (event) {
			$(".terminaciones .items").slick("unslick");
		});

	$("#terminaciones")
		.find('a[data-toggle="tab"]')
		.on("shown.bs.tab", function (event) {
			$(".terminaciones .items").slick({
				infinite: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				autoplay: true,
				dots: false,
				arrows: false,
				responsive: [
					{
						breakpoint: 992,
						settings: {
							slidesToShow: 3,
						}
					},
					{
						breakpoint: 738,
						settings: {
							slidesToShow: 2,
						}
					}
				]
			});
		});

	/* $(".modelos .modelos").slick({
		infinite: false,
		slidesToShow: 3,
		slidesToScroll: 1,
		autoplay: false,
		dots: false,
		prevArrow:
			'<a class="slick-arrow slick-arrow-prev" href="javascript:void(null);">&lsaquo;</a>',
		nextArrow:
			'<a class="slick-arrow slick-arrow-next" href="javascript:void(null);">&rsaquo;</a>',
		responsive: [
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 2,
				},
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 1,
				},
			},
		],
	}); */
});
